import { createComponent } from '@mtfe/sweet';
import { common, dom, eventBus } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import componentUtils from '../utils/index';
import { COUPON_STATUS } from '../constants/index';

const { getGiftEventName } = componentUtils;
const { isFunction, createUniqueId } = common;

const redBagAreaBId = createUniqueId();

const changeWrapper = (style) => {
    const redBagAreaBDom = dom.$id(redBagAreaBId);
    if (redBagAreaBDom) {
        redBagAreaBDom.className = style;
    }
};

/**
 * 领取红包区域
 * @param {object} props
 * @param {object} giftInfo 红包参数
 * @param {function} [props.onClickBtn] 点击按钮回调
 * @returns
 */
const RedBagAreaB = (props = {}) => {
    const { giftInfo, onClickBtn = () => {} } = props;

    let {
        coupon_amount: value,
        order_amount_limit: threshold,
        status,
        gift_id: giftId,
    } = giftInfo;
    const canReceive = status === COUPON_STATUS.STATUS_NEW;

    value = value / 100;
    threshold = threshold / 100;
    if (value === undefined) {
        throw new Error('RedBagAreaA Error: The parameter value is missing.');
    }
    if (threshold === undefined) {
        throw new Error(
            'RedBagAreaA Error: The parameter threshold is missing.',
        );
    }
    const events = {
        onClickReceive: async () => {
            if (isFunction(onClickBtn)) {
                try {
                    await onClickBtn();
                } catch (error) {
                    console.error(error);
                }
            }
        },
    };
    const eventName = getGiftEventName(giftId);
    eventBus.$onceOn(eventName, (newStatus) => {
        if (newStatus === COUPON_STATUS.STATUS_NEW) {
            giftInfo.status = COUPON_STATUS.STATUS_NEW;
            changeWrapper(style.redBagAreaBRecv);
        } else if (newStatus === COUPON_STATUS.STATUS_RECEIVED) {
            giftInfo.status = COUPON_STATUS.STATUS_RECEIVED;
            changeWrapper(style.redBagAreaBUse);
        }
    });
    const data = {
        value,
        threshold,
        redBagAreaBId,
    };
    style.redBagAreaB = canReceive
        ? style.redBagAreaBRecv
        : style.redBagAreaBUse;

    return createComponent(tpl, { style, data }, events);
};

export default RedBagAreaB;
